import React from 'react';
import { Link } from 'react-router';

import {
    WithGoogleAnalyticsInjectedProps,
    withGoogleAnalytics,
} from '../services/google-analytics';
import { CommonComponentProps } from '../types/components';

type Props = CommonComponentProps &
    WithGoogleAnalyticsInjectedProps & {
        href: string | object;
    };

class InternalLink extends React.Component<Props> {
    render() {
        const { children, href, trackSceneView, trackEvent, trackCustom, ...props } = this.props;
        return (
            <Link
                to={href}
                // below works because of the Proxy defined in the Google Analytics HOC
                onClick={this.handleClick}
                {...props}
            >
                {children}
            </Link>
        );
    }
}

export default withGoogleAnalytics({
    trackMethods: (props) => ({
        handleClick: (ev) =>
            props.trackEvent({
                category: 'Internal Link',
                action: 'Click',
                label: ev.currentTarget.textContent,
            }),
    }),
})(InternalLink);
